import styled from 'styled-components';

export const AvatarBlock = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  flex-shrink: 0;
`;
